import {
  Checkbox as MUICheckbox,
  FormControlLabel,
  CheckboxProps as MUICheckboxProps,
} from '@mui/material';

import { useCheckbox } from './useCheckbox';

export type LocalCheckboxProps = {
  id: string;
  displayLabel: React.ReactNode;
  displayLabelSize?: 'normal' | 'medium' | 'small';
  showBorderBox?: boolean;
  noHover?: boolean;
  onChange?: (id: string, checked: boolean) => void;
  width?: string | number;
};

export type CheckboxProps = LocalCheckboxProps & Omit<MUICheckboxProps, 'onChange'>;

export function Checkbox(props: CheckboxProps) {
  const { id, displayLabel, showBorderBox, noHover, width, onChangeHandler, labelStyle, ...rest } =
    useCheckbox(props);

  return (
    <FormControlLabel
      control={
        <MUICheckbox
          {...rest}
          onChange={onChangeHandler}
          sx={noHover ? { backgroundColor: 'transparent' } : { '&:hover': { borderRadius: '4px' } }}
        />
      }
      label={<span style={labelStyle}>{displayLabel}</span>}
      sx={{
        ...(showBorderBox && {
          border: '1px solid #252a36',
          borderRadius: '4px',
          padding: '7px 4px',
          backgroundColor: '#fff',
        }),
        width: width || 'auto', // Apply the width style
      }}
    />
  );
}

export default Checkbox;
